//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations, mapGetters } from 'vuex';

import ButtonBlock from 'components/blocks/Button.vue';
import ImageBlock from 'components/blocks/Image.vue';

export default{
  components: {
    ButtonBlock,
    ImageBlock,
  },
  data() {
    return {
      showGetStarted: false,
      hasSwitchedSection: false,
      isPageIndex: false,
      links: {
        EN: [
          // {
          //   path: '/',
          //   text: 'Home'
          // },
          {
            path: '/service',
            text: 'About'
          },
          {
            path: '/contentcommerce',
            text: 'FAQ'
          },
          {
            path: '/publishers',
            text: 'Content Maker'
          },
          {
            path: '/sellers',
            text: 'Brand'
          },
          {
            path: '/career',
            text: 'Career'
          },
          {
            path: '/news',
            text: 'Support'
          },
          {
            path: '/press',
            text: 'Contact'
          },
          {
            path: '/about',
            text: 'Contact'
          },
          {
            path: '/terms',
            text: 'Contact'
          },
        ],
        SV: [
          // {
          //   path: '/',
          //   text: 'Hem'
          // },
          {
            path: '/service',
            text: 'Om'
          },
          {
            path: '/contentcommerce',
            text: 'Vanliga frågor'
          },
          {
            path: '/publishers',
            text: 'Content Maker'
          },
          {
            path: '/sellers',
            text: 'Varumärke'
          },
          {
            path: '/career',
            text: 'Karriär'
          },
          {
            path: '/news',
            text: 'Support'
          },
          {
            path: '/press',
            text: 'Kontakt'
          },
          {
            path: '/about',
            text: 'Contact'
          },
          {
            path: '/terms',
            text: 'Contact'
          },
        ],
      }
    }
  },
  computed: {
    ...mapGetters([
      'currentSection',
      'sections',
      // 'language'
    ]),
    pagePath() {
      const page = this.$route.path.split('/')[1] || '';
      return (this.isNumeric(page)) ? '/' : '/' + page;
    }
  },
  methods: {
    ...mapMutations([
      'setCurrentSection',
      'openGetStartedMenu',
      'closeGetStartedMenu'
    ]),
    getIsPageIndex() {
      return this.$route.path == "/"
    },
    isNumeric(n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    },
    goToDemo() {
      window.location.href = 'https://demo.spotin.com'
    },
    getStarted() {
      this.showGetStarted = !this.showGetStarted;
    },
    getStartedClosed() {
      this.showGetStarted = false;
    },
  },
  watch: {
    currentSection() {
      this.hasSwitchedSection = true;
    },
    $route() {
      this.isPageIndex = this.getIsPageIndex();
    },
  },
  mounted() {
    this.isPageIndex = this.getIsPageIndex();
  }
}



// WEBPACK FOOTER //
// ./components/globalBlocks/Footer.vue